export const mentionRegex = /^@[a-zA-Z0-9ąćęłńóśźżĄĆĘŁŃÓŚŹŻ#_@\-]+/;
export const mentionRegexExplicit = /^@{[a-zA-Z0-9ąćęłńóśźżĄĆĘŁŃÓŚŹŻ#_@\-. ]+}/;

export const UserMention = {
  defineNodes: ['UserMention'],
  parseInline: [{
    name: 'UserMention',
    parse(context, next, pos) {
      if (next === 64) { // code 64 is character @
        if (/\w/.test(context.slice(pos - 1, pos))) {
          return -1;
        }
        return parsedMention(context, pos, context.slice(pos, Math.min(context.end, pos + 48)));
      }
    }
  }]
};

function parsedMention(context, pos, editorString) {
  const match = matchUserMention(editorString);
  if (match) {
    return context.addElement(context.elt('UserMention', pos, pos + match[0].length));
  }
}

function matchUserMention(string) {
  return mentionRegex.exec(string) || mentionRegexExplicit.exec(string);
}
